import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/controls/')({
    beforeLoad: ({ params }) => {
        throw redirect({ to: '/console/$orgId/controls/register', params, replace: true });
    },
});
